import _ from 'underscore';
import ko from 'knockout';
import { appendLearnMoreLink } from '@bingads-webui-component-legacy/help/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class ViewModel {
  constructor() {
    this.errorMessage = ko.observable('');

    this.showError = ko.computed(() => {
      return !_.isEmpty(this.errorMessage());
    }, this);

    this.infoMessage = ko.observable('');

    this.showInfo = ko.computed(() => {
      return !_.isEmpty(this.infoMessage());
    }, this);

    this.hasUnsupportedLocations = ko.observable(false);
    this.showSearchBidValidationError = ko.observable(false);

    this.infoMessageWithLearnMore = ko.computed(() => {
      if (this.hasUnsupportedLocations()) {
        return appendLearnMoreLink(this.infoMessage(), 'app54508', {
          linkText: i18n.get('HelpLink_TrafficEstimate_UnsupportedLocations'),
        });
      }

      return this.infoMessage();
    });
  }
}
